import Modal from '../../shared/components/Modal';
import LingokidsLogo from '../../resources/images/lingokids_logo.png';

const LingokidsApplicationResultModal = ({ showApplicationResultModal, closeApplicationResultModal, message }) => {
  return (
    <Modal show={showApplicationResultModal} closeModal={closeApplicationResultModal}>
      <div className={'max-w-[300px]'}>
        <div className={'flex justify-center'}>
          <div className={'w-[150px]'}>
            <img src={LingokidsLogo} alt={'LingokidsLogo'}/>
          </div>
        </div>
        <div className={'font-[nanum-square-b] mt-[20px]'}>
          {message}
        </div>
      </div>
    </Modal>
  );
};

export default LingokidsApplicationResultModal;
